import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 8.8.",
  "description": "",
  "published": "2011-08-08T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-8-8/swizec/2105"],
  "categories": "Coconut, CoconutWater, Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/9c46947719ee42638b2398044298e725_75.jpg",
        "alt": null,
        "title": "Coconut Water"
      }}></img></p>
    <p>{`Today I learned that Coconut water tastes really really really bad. Half the people in this house seem to be drinking it every day and loving every little sip of the thing. Went and bought some ... tasted it ... after two sips I donated it. And I generally really like coconut, but this water thing is just no good.`}</p>
    <p>{`Not sure how to describe the taste, but it's not unlike someone smeared broccoli dipped in milk and mashed together with a touch of mansack sweat all over my tongue. And that's not doing justice to the taste of mansack sweat.`}</p>
    <p>{`I also learned never never never to have a set of code in only one location on only one computer. Working on a small prototype of a prototype of something and we decided to only use local git repositories because it would be too much of an unneeded pain to have something on a real server somewhere.`}</p>
    <p>{`Needless to say, I did something stupid and lost a day of work.`}</p>
    <p>{`Was moving some directories around ... removed the wrong one. Poof. Code gone. All my modifications just fucking vanished into thin air. Yay for me!`}</p>
    <p>{`Git sucks for backup and making sure work doesn't vanish when you accidentally the whole thing.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.fitsugar.com/Benefits-Coconut-Water-Dehydration-18275172"
        }}>{`Need to Beat the Heat? Stock Up on Coconut Water`}</a>{` (fitsugar.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://r.zemanta.com/?u=http%3A//well.blogs.nytimes.com/2011/08/08/really-the-claim-for-better-hydration-drink-coconut-water/&a=51160725&rid=c47ace11-538d-492d-9d83-d4e4fd7380f9&e=95ebbd91439b5d47e85ef5395ef21a23"
        }}>{`Really? The Claim: For Better Hydration, Drink Coconut Water`}</a>{` (well.blogs.nytimes.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.newser.com/story/125338/coconut-water-not-so-magically-healthy-after-all.html"
        }}>{`Coconut Water: Not So Magically Healthy After All?`}</a>{` (newser.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=c47ace11-538d-492d-9d83-d4e4fd7380f9",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      